import React from 'react';
import CreateBudget, { ICreateBudgetProps } from '../CreateBudget/CreateBudget';
import { BudgetInstance } from '../CreateBudget/CreateBudgetForm';
import { useGetBudgetQuery } from '../../../graphql/datamodel.gen';
import { getClient } from '../../../apollo';
import { instantiateBudgetFromNetworkResponse } from '../CreateItinerary/utils';
import { NetworkStatus } from '@apollo/client';
interface IEditBudgetProps extends Omit<ICreateBudgetProps, 'budget'> {
  budgetId: string;
}

const EditBudget = (props: IEditBudgetProps) => {
  const { loading, data, error, refetch, networkStatus } = useGetBudgetQuery({
    client: getClient(),
    variables: {
      id: props.budgetId,
    },
    returnPartialData: true,
    fetchPolicy: 'cache-and-network',

    skip: !props.budgetId,
  });

  const budget = data?.budget;
  return (
    <CreateBudget
      draft={false}
      {...props}
      refetchBudget={refetch}
      // @ts-ignore
      {...(budget && {
        // @ts-ignore
        budget: instantiateBudgetFromNetworkResponse(budget),
      })}
      // loading={loading && networkStatus === NetworkStatus.setVariables}
      loading={loading}
    />
  );
};

export default EditBudget;
